
    import { Vue, Component, Prop } from 'vue-property-decorator'

    @Component
    export default class MethodSelectionCard extends Vue {
        @Prop({ type: String, required: true }) icon!: string
        @Prop({ type: String, required: true }) title!: string
        @Prop({ type: Array, required: true }) benefits!: string[]
        @Prop({ type: String, default: '' }) note!: string
        @Prop({ type: String, default: 'warning' }) noteType!: 'warning' | 'error' | 'info'
        @Prop({ type: Boolean, default: false }) disabled!: boolean
        @Prop({ type: Boolean, default: false }) showPreviousChip!: boolean
        @Prop({ type: String, default: '' }) previousMethodLabel!: string
        @Prop({ type: String, default: 'Select' }) selectLabel!: string

        get noteIconColor(): string {
            const colors: Record<string, string> = {
                warning: 'warning',
                error: 'error',
                info: 'info'
            }
            return colors[this.noteType] || 'warning'
        }

        get noteIcon(): string {
            const icons: Record<string, string> = {
                warning: 'fal fa-info-circle',
                error: 'fal fa-exclamation-triangle',
                info: 'fal fa-info-circle'
            }
            return icons[this.noteType] || 'fal fa-info-circle'
        }
    }
